import Box from '@mui/material/Box';

import { ScaffolderInputHeader } from '../../../components';
import { KAAP_CLUSTER_INFO } from '../infoDoc';
import { KaapCluster, KaapTenant } from '../types';
import { KaapTenantPicker } from './KaapTenantPicker';
import { NamespaceInput } from './NamespaceInput';

export interface KaapClusterPickerProps {
  formData: KaapCluster;
  onChange: (data: KaapCluster) => void;
  rawErrors: string[];
}

export const KaapClusterPicker = (props: KaapClusterPickerProps) => {
  const { formData, onChange, rawErrors } = props;

  const handleClusterChange = (tenant: KaapTenant | string = '') => {
    if (!tenant) {
      onChange({ tenant: null, namespaces: [] });
      return;
    }

    const tenantName = typeof tenant === 'string' ? tenant : tenant.name;
    onChange({
      tenant:
        typeof tenant === 'string' ? { name: tenant, clusterId: null } : tenant,
      namespaces: [`kaap-${tenantName}-*`],
    });
  };

  const handleNamespacesChanged = (namespaces: string[]) => {
    onChange({
      ...(formData || { tenant: null, namespaces: [] }),
      namespaces,
    });
  };

  return (
    <Box>
      <ScaffolderInputHeader
        title="Tenant"
        description="Select the tenant for this cluster."
        infoDoc={KAAP_CLUSTER_INFO}
      />
      <KaapTenantPicker
        title="Tenant Name"
        type="object"
        formData={formData?.tenant || ''}
        onChange={handleClusterChange}
        rawErrors={rawErrors}
        required
      />
      <NamespaceInput
        formData={formData?.namespaces || []}
        onChange={handleNamespacesChanged}
        rawErrors={rawErrors}
        disabled
      />
    </Box>
  );
};
